import { History } from "history";

import {
  ADD_PROMO_CODE,
  ADD_PROMO_CODE_ERROR,
  ADD_PROMO_CODE_SUCCESS,
  AddPromoCodeAction,
  AddPromoCodeErrorAction,
  AddPromoCodeSuccessAction,
  DELETE_PROMO_CODE,
  DELETE_PROMO_CODE_CONSENT,
  DELETE_PROMO_CODE_ERROR,
  DELETE_PROMO_CODE_SUCCESS,
  DeletePromoCodeAction,
  DeletePromoCodeConsentAction,
  DeletePromoCodeErrorAction,
  DeletePromoCodeSuccessAction,
  GET_PROMO_CODE,
  GET_PROMO_CODES,
  GET_PROMO_CODES_ERROR,
  GET_PROMO_CODES_SUCCESS,
  GET_PROMO_CODE_ERROR,
  GET_PROMO_CODE_SUCCESS,
  GetPromoCodeAction,
  GetPromoCodeErrorAction,
  GetPromoCodeSuccessAction,
  GetPromoCodesAction,
  GetPromoCodesErrorAction,
  GetPromoCodesSuccessAction,
  UPDATE_PROMO_CODE,
  UPDATE_PROMO_CODE_ERROR,
  UPDATE_PROMO_CODE_SUCCESS,
  UpdatePromoCodeAction,
  UpdatePromoCodeErrorAction,
  UpdatePromoCodeSuccessAction,
} from "./actionTypes";
import {
  CreatePromoCodeRequest,
  PromoCodeDto,
  PaginateQuery,
  UpdatePromoCodeRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get Promo Codes

export const getPromoCodes = (
  request: PaginateQuery,
  history: History
): GetPromoCodesAction => {
  return {
    type: GET_PROMO_CODES,
    payload: { request, history },
  };
};

export const getPromoCodesSuccess = (
  response: Paginated<PromoCodeDto>
): GetPromoCodesSuccessAction => {
  return {
    type: GET_PROMO_CODES_SUCCESS,
    payload: response,
  };
};

export const getPromoCodesError = (error: any): GetPromoCodesErrorAction => {
  return {
    type: GET_PROMO_CODES_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Promo Code

export const getPromoCode = (
  id: string,
  history: History
): GetPromoCodeAction => {
  return {
    type: GET_PROMO_CODE,
    payload: { id, history },
  };
};

export const getPromoCodeSuccess = (
  response: PromoCodeDto
): GetPromoCodeSuccessAction => {
  return {
    type: GET_PROMO_CODE_SUCCESS,
    payload: response,
  };
};

export const getPromoCodeError = (error: any): GetPromoCodeErrorAction => {
  return {
    type: GET_PROMO_CODE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Promo Code

export const addPromoCode = (
  request: CreatePromoCodeRequest,
  history: History
): AddPromoCodeAction => {
  return {
    type: ADD_PROMO_CODE,
    payload: { request, history },
  };
};

export const addPromoCodeSuccess = (): AddPromoCodeSuccessAction => {
  return {
    type: ADD_PROMO_CODE_SUCCESS,
    payload: null,
  };
};

export const addPromoCodeError = (error: any): AddPromoCodeErrorAction => {
  return {
    type: ADD_PROMO_CODE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Promo Code

export const updatePromoCode = (
  id: string,
  request: UpdatePromoCodeRequest,
  history: History
): UpdatePromoCodeAction => {
  return {
    type: UPDATE_PROMO_CODE,
    payload: { id, request, history },
  };
};

export const updatePromoCodeSuccess = (): UpdatePromoCodeSuccessAction => {
  return {
    type: UPDATE_PROMO_CODE_SUCCESS,
    payload: null,
  };
};

export const updatePromoCodeError = (
  error: any
): UpdatePromoCodeErrorAction => {
  return {
    type: UPDATE_PROMO_CODE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Promo Code

export const deletePromoCodeConsent = (
  id: string
): DeletePromoCodeConsentAction => {
  return {
    type: DELETE_PROMO_CODE_CONSENT,
    payload: id,
  };
};

export const deletePromoCode = (
  id: string,
  history: History
): DeletePromoCodeAction => {
  return {
    type: DELETE_PROMO_CODE,
    payload: { id, history },
  };
};

export const deletePromoCodeSuccess = (): DeletePromoCodeSuccessAction => {
  return {
    type: DELETE_PROMO_CODE_SUCCESS,
    payload: null,
  };
};

export const deletePromoCodeError = (
  error: any
): DeletePromoCodeErrorAction => {
  return {
    type: DELETE_PROMO_CODE_ERROR,
    payload: error,
  };
};

//#endregion
